export const ACTION_PREFIX = 'MODULE/PROJECT'

const keyValue = (key, value) => ({
  key,
  value,
})

export const PropertyTypes = [
  keyValue(0, 'detached_house'),
  keyValue(1, 'collective_housing_apartment'),
  keyValue(2, 'office_building'),
  keyValue(3, 'commercial_facility'),
  keyValue(4, 'medical_welfare'),
  keyValue(5, 'educational_institutions'),
  keyValue(6, 'public_facility'),
  keyValue(7, 'others'),
]

export const ConstructionTypes = [
  keyValue(0, 'new_construction'),
  keyValue(1, 'large_scale_renovation'),
  keyValue(2, 'interior_construction'),
  keyValue(3, 'home_improvement'),
  keyValue(4, 'others'),
]

export const ConstructionAreas = [
  keyValue(0, { value: 50, unit: 'm2', label: '~50 m2' }),
  keyValue(1, { value: 100, unit: 'm2', label: '~100 m2' }),
  keyValue(2, { value: 200, unit: 'm2', label: '~200 m2' }),
  keyValue(3, { value: 500, unit: 'm2', label: '~500 m2' }),
  keyValue(4, { value: 1000, unit: 'm2', label: '~1000 m2' }),
  keyValue(5, { value: 10000, unit: 'm2', label: '~10000 m2' }),
  keyValue(6, { value: 50000, unit: 'm2', label: '~50000 m2' }),
]

/**
 * Enum of FilterBy Key
 */
export const FilterBy = {
  Keyword: 'keyword',
}
